<template lang="html">
  <div class="codebook-wrapper">
    <div class="overflow-wrapper">
      <div class="list-wrapper">
        <div class="list-header">
          {{codebookData.label}}
        </div>
        <div class="items-wrapper">
          <div v-for="info in codebookInfo" :key="info[codebookData.key]" class="list-item">
            <span v-if="codebookData.name === 'rst_name'">{{info[codebookData.name]}}, {{info.rst_start_time}} - {{info.rst_end_time}}</span>
            <span v-else>{{info[codebookData.name]}}</span>
            <div class="icons-wrapper">
              <img v-if="info[codebookData.active] === 1" @click="confirmChengeActive(false, info)" src="@/assets/icons/trash.png" alt="trash icon">
              <img v-else @click="chengeActive(true, info)" src="@/assets/icons/repeat.png" alt="trash icon">
              <img v-if="codebookData.edit" @click="edit(info)" src="@/assets/icons/pen.png" alt="edit">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="codebookData.post" @click="addNew" class="btn">
      dodaj
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
export default {
  name: 'codebook',
  props: {
    codebookData: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      codebookInfo: []
    }
  },
  mounted () {
    this.getCodebookData()
    eventBus.$on('closeModal', () => {
      this.getCodebookData()
    })
  },
  methods: {
    getCodebookData () {
      api[this.codebookData.getApi]().then(res => {
        this.codebookInfo = res.data.data
      })
    },
    confirmChengeActive (active, data) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovo polje iz šifarnika',
        ok: () => {
          this.chengeActive(active, data)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    chengeActive (active, data) {
      let params = {}
      params[this.codebookData.key] = data[this.codebookData.key]
      params[this.codebookData.active] = active
      api[this.codebookData.patchApi](params).then(res => {
        this.getCodebookData()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    addNew () {
      this.codebookData.post.refresh = this.getCodebookData
      let params = {
        modalData: this.codebookData.post,
        component: this.codebookData.label === 'kategorije' ? 'addCodebookCategory':'addCodebook'
      }
      eventBus.$emit('openModal', params)
    },
    edit (info) {
      let params = {
        modalData: info,
        component: this.codebookData.edit
      }
      eventBus.$emit('openModal', params)
    },
  },
  watch: {
    codebookData: {
      handler: function () {
        this.getCodebookData()
      }
    },
    '$route.params.lang': {
      handler: function () {
        this.getCodebookData()
      }
    }
  },
  destroyed () {
    eventBus.$off('closeModal')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/btnStyles.scss';
.codebook-wrapper {
  height: 100%;
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .overflow-wrapper {
    height: 90%;
    position: relative;
  }
  .list-wrapper {
    width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-transform: uppercase;
    margin-bottom: 40px;

    .items-wrapper {
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;
      overflow: hidden;
      overflow: auto;
      height: 100%;
      width: 300px;
    }

    .icons-wrapper {
      display: flex;
      flex-direction: row;

      img {
        margin-left: 10px;
      }
    }

    .list-header {
      height: 50px;
      font-weight: 800;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 0.06em;
      color: rgba(160, 160, 160, 0.9);
      display: flex;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      padding: 0px 10px;
    }
    .list-item {
      height: auto;
      min-height: 50px;
      font-weight: 600;
      font-size: 15px;
      line-height: 25px;
      letter-spacing: 0.06em;
      color: #606060;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 10px;
      text-align: left;

      span {
        max-width: 100%;
        word-break: break-word;
      }

      img {
        cursor: pointer;
      }
    }
    .list-item:nth-child(even) {
      background: rgba(196, 196, 196, .15);
    }
  }
  .btn {
    max-width: 150px;
  }
}
</style>
